import React from 'react';
import ApprovalOutlinedIcon from '@mui/icons-material/ApprovalOutlined';
import {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function AuthorizationIcon(props: SvgIconProps) {
  return <ApprovalOutlinedIcon {...props} />;
}
